module.exports = __webpack_public_path__ + "static/media/answer_img3.4641ade7.png";